"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _utils = require("./utils");

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  menuList: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 3.5em"
  },
  menuItem: {
    position: "relative",
    width: '8em',
    margin: ".5em"
  },
  figure: {
    paddingBottom: "100%",
    borderRadius: "100%",
    backgroundColor: "white"
  },
  title: {
    color: "white",
    textAlign: "center",
    lineHeight: 1.25,
    height: "2.5em",
    margin: theme.spacing(1)
  }
}));

const MenuItem = ({
  title
}) => {
  const classes = useStyles();
  return _react.default.createElement("article", {
    className: classes.menuItem
  }, _react.default.createElement("figure", {
    className: classes.figure
  }), _react.default.createElement(_Typography.default, {
    className: classes.title
  }, title));
};

const Menu = ({
  items,
  onCurrentId
}) => {
  const classes = useStyles();

  const TimelineItem = (_ref) => {
    let cols = _ref.cols,
        rows = _ref.rows,
        index = _ref.index,
        item = _objectWithoutPropertiesLoose(_ref, ["cols", "rows", "index"]);

    const id = "root_content_pageLinks_" + index;
    return _react.default.createElement(MenuItem, _extends({}, item, {
      onClick: () => onCurrentId(id)
    }));
  };

  return _react.default.createElement("div", {
    className: classes.menuList
  }, items && items.map((item, index) => {
    const itemProps = (0, _utils.getPreviewItem)(_extends({}, item, {
      index: index
    }));
    return _react.default.createElement(TimelineItem, _extends({}, itemProps, {
      key: index
    }));
  }));
};

const PreviewTimeline = ({
  formData,
  formContext,
  width,
  height
}) => {
  const _formData$content = formData.content,
        pageTitle = _formData$content.pageTitle,
        backgroundImage = _formData$content.backgroundImage,
        hasPages = _formData$content.hasPages;
  const currentLocale = formContext && formContext[currentLocale];
  const title = pageTitle && pageTitle[currentLocale] || formData.title;
  const onCurrentId = formContext.onCurrentId;
  const classes = useStyles();
  return _react.default.createElement("div", {
    className: classes.root
  }, _react.default.createElement(Menu, {
    items: hasPages,
    width: width,
    height: height,
    onCurrentId: onCurrentId
  }));
};

var _default = PreviewTimeline;
exports.default = _default;
module.exports = exports.default;